module.exports = __webpack_public_path__ + "static/media/move-left.3d876740.svg";